import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pandabuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/pandabuy-spreadsheet-sneakers",
    element: <ArticlePage />,
  },
  {
    path: "/budget-pandabuy-finds-under-50",
    element: <ArticlePage />,
  },
  {
    path: "/pandabuy-spreadsheet-luxury-brands",
    element: <ArticlePage />,
  },
  {
    path: "/summer-pandabuy-fashion-finds",
    element: <ArticlePage />,
  },
  {
    path: "/winter-pandabuy-spreadsheet-collection",
    element: <ArticlePage />,
  },
  {
    path: "/pandabuy-spreadsheet-for-beginners",
    element: <ArticlePage />,
  },
  {
    path: "/best-pandabuy-hoodies-collection",
    element: <ArticlePage />,
  },
  {
    path: "/pandabuy-accessories-guide",
    element: <ArticlePage />,
  },
  {
    path: "/pandabuy-spreadsheet-vs-manual-search",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;